<div class="row" *ngIf="isComercial">
    <div class="col-md col-xs col-xl col-sm wd-100-pc">
        <mat-card class="mat-elevation-z8 wd-100-pc">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Avaliação Final
                                </mat-label>
                                <mat-select #txtAvalFinal formControlName="avaliacao_final" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterAvaliacaoFinal($event.target.value)">
                                    <mat-option *ngFor="let item of listAvaliacaoFinal" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.avaliacao_final)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso Estimado (kg)
                                </mat-label>
                                <input matInput id="txtPesoEstim" #txtPesoEstim maxlength="10"
                                    formControlName="peso_estimado_kg" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtPesoEstim.value.length}} / 10
                                </mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.peso_estimado_kg)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Silo Destino</mat-label>
                                <mat-select #txtSiloDestino formControlName="silo_destino" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Selecione um campo">
                                    <mat-option *ngFor="let item of listSiloDestino" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.silo_destino)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Usuário</mat-label>
                                <input matInput id="txtUsuario" #txtUsuario maxlength="100" formControlName="usuario"
                                    readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtUsuario.value.length}} / 100</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.usuario)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Observação</mat-label>
                                <textarea matInput id="txtObs" #txtObs maxlength="255"
                                    formControlName="observacao"></textarea>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtObs.value.length}} / 255</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.observacao)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                    floatLabel="{{formFieldFloatLabel}}">
                                    <mat-label class="InputLabelColor">Criado por</mat-label>
                                    <input matInput id="txtCriadoPor" #txtCriadoPor maxlength="40"
                                        formControlName="criado_por" readonly class="InputBlockColor">
                                    <i matSuffix class="{{iconDisableField}}"></i>
                                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                    <mat-hint align="end">{{txtCriadoPor.value.length}} / 40</mat-hint>
                                    <mat-error>{{hasErrorFormControl(formulario.controls.criado_por)}}
                                    </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>

<div class="row" *ngIf="isBasica">
    <div class="col-md col-xs col-xl col-sm wd-100-pc">
        <mat-card class="mat-elevation-z8 wd-100-pc">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Avaliação Final
                                </mat-label>
                                <mat-select #txtAvalFinal formControlName="avaliacao_final" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterAvaliacaoFinal($event.target.value)">
                                    <mat-option *ngFor="let item of listAvaliacaoFinal" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.avaliacao_final)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Responsável pela Autorização Especial </mat-label>
                                <textarea matInput id="txtResponsavelAutorizacaoEspecial"
                                    #txtResponsavelAutorizacaoEspecial maxlength="60"
                                    formControlName="responsavel_autorizacao_especial"></textarea>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtResponsavelAutorizacaoEspecial.value.length}} / 60</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.observacao)}}</mat-error>
                                <!-- corrigir erro-->
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Silo Destino</mat-label>
                                <mat-select #txtSiloDestino formControlName="silo_destino" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Selecione um campo">
                                    <mat-option *ngFor="let item of listSiloDestino" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.silo_destino)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Usuário</mat-label>
                                <input matInput id="txtUsuario" #txtUsuario maxlength="100" formControlName="usuario"
                                    readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtUsuario.value.length}} / 100</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.usuario)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Observação</mat-label>
                                <textarea matInput id="txtObs" #txtObs maxlength="255"
                                    formControlName="observacao"></textarea>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtObs.value.length}} / 255</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.observacao)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Responsável pela análise</mat-label>
                                <textarea matInput id="txtResponsavelAnalise" #txtResponsavelAnalise maxlength="60"
                                    formControlName="responsavel_pela_analise"></textarea>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtResponsavelAnalise.value.length}} / 60</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.observacao)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Justificativa Aprovação especial </mat-label>
                                <textarea matInput id="txtJustificativaAprovacaoEspecial"
                                    #txtJustificativaAprovacaoEspecial maxlength="200"
                                    formControlName="justificativa_aprovacao_especial"></textarea>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtJustificativaAprovacaoEspecial.value.length}} / 200
                                </mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.observacao)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                    floatLabel="{{formFieldFloatLabel}}">
                                    <mat-label class="InputLabelColor">Criado por</mat-label>
                                    <input matInput id="txtCriadoPor" #txtCriadoPor maxlength="40"
                                        formControlName="criado_por" readonly class="InputBlockColor">
                                    <i matSuffix class="{{iconDisableField}}"></i>
                                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                    <mat-hint align="end">{{txtCriadoPor.value.length}} / 40</mat-hint>
                                    <mat-error>{{hasErrorFormControl(formulario.controls.criado_por)}}
                                    </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>
